import axios from 'axios'
import _ from 'lodash'
import { getAppBaseUrl } from './api'
const BASE_URL = getAppBaseUrl()

export const sendModelOnlineEmailNotification = (email_type) => async (dispatch) => {
    try {
        await axios.post(`${BASE_URL}/api/send-model-online-notification`, { email_type })
        return
    } catch (error) {
        const errorMessage = _.get(error.response, 'data.message', 'There was a problem sending email')
        console.log(errorMessage)
        return
    }
}

